// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"0e745c48","236":"de881d82","295":"109a57aa","453":"1310e2c0","459":"172691b2","536":"c8718282","824":"1822ec49","894":"1e76d8e4"}[chunkId] + ".chunk.js";
};